import * as braze from '@braze/web-sdk';
import { useEffect, useRef } from 'react';
import { initPageCall, trackPage } from 'Utils/Analytics';
import { trackPageSource } from 'State/Tracking';
import { getPathRoot } from 'Utils/Braze';
import { getXid, submitXidEvent } from 'Api/ProfileApi';
import { loadFennec } from 'Utils/Analytics/Fennec';

const Tracking = ({ title, location, eventName, children }) => {
  const firstPageCall = useRef(true);
  const firstXidCall = useRef(true);

  useEffect(() => {
    const { state, pathname } = location;
    const pageSource = (state && state.page_source) || null;
    if (pageSource) trackPageSource(pageSource);

    if (title && location) {
      if (firstPageCall.current) {
        initPageCall(title, location.pathname, eventName);
        firstPageCall.current = false;
      } else {
        trackPage(title, location.pathname, eventName);
      }
    }

    const pathRoot = getPathRoot(pathname);
    braze.logCustomEvent('Page_Load', {
      path: pathname,
      pathRoot,
    });
  }, [location, title, eventName]);

  useEffect(() => {
    const xidPageViewEvent = async () => {
      try {
        const { xid } = getXid();
        await submitXidEvent(xid);
        if (firstXidCall.current) {
          firstXidCall.current = false;
          loadFennec();
        }
      } catch (error) {
        console.error(error.message);
      }
    };

    xidPageViewEvent();
  }, [location.pathname]);

  return children;
};

export default Tracking;
